import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import storage from '../../../services/stoage.service'
import utils, { getMessage, isArrayNullOrEmpty } from '../../../utils'
import { actions } from '../movimentoestoque.actions'
import { Button } from 'primereact/button'
import * as listPageUtils from '../../../utils/listPageContainerUtils'
import { logarAcesso } from '../../../services/api-log-acesso'
import { MovimentoEstoqueForm } from './MovimentoEstoqueForm'
import _ from 'lodash'
import apiService from '../../../services/api-id-value-service'
import { routes } from '../../../constants'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'

const mapStateToProps = (state) => {
  const messages = state.crudMovimentoEstoqueState.messages
  const record = state.crudMovimentoEstoqueState.currentRecord
  const item = state.crudMovimentoEstoqueState.item
  const itens = state.crudMovimentoEstoqueState.itens || []
  const saldoEstoque = state.crudMovimentoEstoqueState.saldoEstoque || 0

  const currentUnit = storage.getUnit()
  const disableUnit = !!currentUnit

  const currentCompany = storage.getCompany()
  const unidadeMatriz = utils.getIdValueUnidadeMatriz(currentCompany)

  return {
    currentCompany,
    record,
    item,
    messages,
    unidadeMatriz,
    disableUnit,
    itens,
    saldoEstoque,
    currentUnit,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.setType(null))
      dispatch(actions.applyFilter(filterParams))
    },
    setField: (field, value) => dispatch(actions.setField(field, value)),
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let valor = target.value
      dispatch(actions.removeErrors([{ field }]))
      dispatch(actions.setField(field, valor))
    },
    loadFavorito: (menu) => dispatch(actions.loadFavorito(menu)),
    removeFavorito: (menu) => dispatch(actions.removeFavorito(menu)),
    adicionarFavorito: (menu) => dispatch(actions.adicionarFavorito(menu)),
    setItem: (prop, value) => dispatch(actions.setItem(prop, value)),
    addItem: (payload) => dispatch(actions.addItem(payload)),
    onClickRemoveItem: (item) => dispatch(actions.onClickRemoveItem(item)),
    getSaldoEstoque: ({ oidUnidadeOrigem, oidProduto }) =>
      dispatch(actions.getSaldoEstoque({ oidUnidadeOrigem, oidProduto })),
    inventariarEstoque: ({ params }) => dispatch(actions.inventariarEstoque({ params })),
    transferirEstoque: ({ params }) => dispatch(actions.transferirEstoque({ params })),
    reset: () => dispatch(actions.reset()),
    setUnidades: (data) => dispatch(actions.setUnidades(data)),
  }
}

class MovimentoEstoqueFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.showCSVButton = false
    this.showColumnButton = false
    this.hideBtnImportacao = true
    this.state = {
      dadosFavorito: null,
      favorito: 0,
      unidades: [],
    }
    actions.afterLoadFavorito = (data) => {
      if (data && data.oid) {
        this.setState({ favorito: 1 })
        this.setState({ dadosFavorito: data })
      } else {
        this.setState({ favorito: 0 })
        this.setState({ dadosFavorito: null })
      }
    }
  }

  componentDidMount() {
    logarAcesso().then()
    apiService
      .getUnidadesUsuario()
      .then((e) => {
        this.setState({ unidades: e.data || [] })
        setTimeout(() => {
          this.props.setField('unidadeOrigem', this.props.unidadeMatriz)
        }, 300)
      })
      .catch((e) => {
        this.setState({ unidades: [] })
      })
  }

  componentWillUnmount() {}

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_MOVIMENTO_ESTOQUE}`)
  }

  loadFavorito() {
    listPageUtils.loadFavorito(this, actions)
  }

  changeFavorito() {
    listPageUtils.changeFavorito(this, actions)
  }

  gerar = () => {
    const tipo = _.get(this.props.record, 'tipo', null)
    const itens = this.props.itens || []
    if (isArrayNullOrEmpty(itens)) {
      return
    }
    const params = []
    if (tipo === 'inventario') {
      for (const item of itens) {
        params.push({
          unidade: item.unidadeOrigem,
          produto: { id: _.get(item, 'produto.oid', null), value: _.get(item, 'produto.descricao', null) },
          quantidade: item.quantidade,
        })
      }
      this.props.inventariarEstoque({ params })
    } else if (tipo === 'transferencia') {
      for (const item of itens) {
        params.push({
          unidadeOrigem: item.unidadeOrigem,
          unidadeDestino: item.unidadeDestino,
          produto: { id: _.get(item, 'produto.oid', null), value: _.get(item, 'produto.descricao', null) },
          quantidade: item.quantidade,
        })
      }
      this.props.transferirEstoque({ params })
    }
  }

  getCustomButtons = () => {
    return (
      <div className="p-toolbar-group-left">
        <Button
          label={utils.getMessage(this.props.messages, 'movimentoestoque.label.gerar')}
          icon="pi pi-check"
          className="p-button-success"
          onClick={this.gerar}
        />
      </div>
    )
  }

  setProduto = (data) => {
    this.props.setItem('produto', data)
    const tipo = _.get(this.props.record, 'tipo', null)
    if (tipo === 'transferencia') {
      const oidProduto = _.get(data, 'oid', null)
      const oidUnidadeOrigem = _.get(this.props, 'record.unidadeOrigem.id', null)
      if (oidUnidadeOrigem && oidProduto) {
        this.props.getSaldoEstoque({ oidUnidadeOrigem, oidProduto })
      }
    }
  }

  setTipoMovimento = (e) => {
    this.props.reset()
    this.props.setField('tipo', _.get(e, 'target.value', null))
    this.props.setField('unidadeOrigem', this.props.unidadeMatriz)
  }

  buildHeader = () => {
    return (
      <DefaultToolBar
        listPageContainer={this}
        title={getMessage(this.props.messages, 'movimentoestoque.label.titulo')}
        onCustomClickPesquisar={this.searchHandler}
      />
    )
  }

  render() {
    const content = (
      <div>
        <MovimentoEstoqueForm
          currentUser={this.props.currentUser}
          messages={this.props.messages}
          changeHandler={this.props.changeHandler}
          record={this.props.record}
          item={this.props.item}
          disableUnit={this.props.disableUnit}
          unidades={this.state.unidades}
          setField={this.props.setField}
          itens={this.props.itens}
          addItem={this.props.addItem}
          setItem={this.props.setItem}
          onClickRemoveItem={this.props.onClickRemoveItem}
          setProduto={this.setProduto}
          saldoEstoque={this.props.saldoEstoque}
          setTipoMovimento={this.setTipoMovimento}
        />
      </div>
    )

    return <Page content={content} header={this.buildHeader()} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MovimentoEstoqueFormPageContainer)
